// Mock data for Armed Security Service website

export const companyInfo = {
  name: "Armed Security Service",
  tagline: "SMART SOLUTIONS FOR YOUR SECURITY",
  phone: "(866) 555-0123",
  email: "contact@armedsecurityservice.com",
  description: "We offer both armed and unarmed security guards nationwide. Call now for a free quote!"
};

export const services = [
  {
    id: 1,
    title: "24 Hour Fire Watch",
    description: "Our 24 hour Fire Watch Guards are fully equipped and trained to manage all your Fire Watch needs. Call now to get started.",
    image: "https://images.unsplash.com/photo-1618371690240-e0d46eead4b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxzZWN1cml0eSUyMGd1YXJkfGVufDB8fHx8MTc2ODg5MjgxN3ww&ixlib=rb-4.1.0&q=85",
    link: "/services/fire-watch"
  },
  {
    id: 2,
    title: "Security Guards",
    description: "Armed Security Service is the #1 security provider nationwide. Fully bonded & insured. Call or message us now for more information.",
    image: "https://images.unsplash.com/photo-1485230405346-71acb9518d9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzZWN1cml0eSUyMGd1YXJkfGVufDB8fHx8MTc2ODg5MjgxN3ww&ixlib=rb-4.1.0&q=85",
    link: "/services/security-guards"
  },
  {
    id: 3,
    title: "Commercial Security",
    description: "Our commercial security guards are fully trained to protect and secure your commercial property or business 24/7. Call now.",
    image: "https://images.unsplash.com/photo-1766150805252-9cd6c37e899f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBzZWN1cml0eXxlbnwwfHx8fDE3Njg4OTI4Mjh8MA&ixlib=rb-4.1.0&q=85",
    link: "/services/commercial-security"
  },
  {
    id: 4,
    title: "Employee Termination",
    description: "Armed Security Service specializes in escorting high-risk employees off the business premises after a termination. Request more information now.",
    image: "https://images.pexels.com/photos/13657375/pexels-photo-13657375.jpeg",
    link: "/services/employee-termination"
  },
  {
    id: 5,
    title: "Loss Prevention",
    description: "Our loss prevention security team will implement preventative measures to stop shoplifters and other forms of theft.",
    image: "https://images.pexels.com/photos/13657406/pexels-photo-13657406.jpeg",
    link: "/services/loss-prevention"
  },
  {
    id: 6,
    title: "Hospital Security",
    description: "Armed Security Service will prevent unauthorized access to restricted areas of the hospital. Get started now with an on-site assessment.",
    image: "https://images.unsplash.com/photo-1581568736305-49a04e012c13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxzZWN1cml0eSUyMGd1YXJkfGVufDB8fHx8MTc2ODg5MjgxN3ww&ixlib=rb-4.1.0&q=85",
    link: "/services/hospital-security"
  },
  {
    id: 7,
    title: "Hotel Security",
    description: "Our professional hotel security services will ensure the safety of your staff and hotel guests. Request more information.",
    image: "https://images.unsplash.com/photo-1618371731836-2b9bff9ac72a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxzZWN1cml0eSUyMG9mZmljZXJ8ZW58MHx8fHwxNzY4ODkyODQwfDA&ixlib=rb-4.1.0&q=85",
    link: "/services/hotel-security"
  },
  {
    id: 8,
    title: "Dispensary Security",
    description: "If you own a cannabis dispensary, security isn't only smart, but required. Our security service will reduce risk and ensure safety.",
    image: "https://images.pexels.com/photos/19152081/pexels-photo-19152081.jpeg",
    link: "/services/dispensary-security"
  },
  {
    id: 9,
    title: "Construction Site Security",
    description: "Construction site security is vitally important. We'll prevent theft and safeguard expensive machines, tools and other assets.",
    image: "https://images.pexels.com/photos/27299956/pexels-photo-27299956.jpeg",
    link: "/services/construction-security"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Arlind O. Cruz",
    date: "November 4, 2022",
    source: "Google",
    text: "They contracted with Armed Security Service of Palm Beach, Florida, to handle its access control and security. Excellent service and very professional guards."
  },
  {
    id: 2,
    name: "Anthony Turner",
    date: "November 2, 2022",
    source: "Google",
    text: "Our Orlando gated community was given a bundle deal that included both patrolling security and access control. Outstanding value and reliability."
  },
  {
    id: 3,
    name: "Laurent S. Hamilton",
    date: "November 2, 2022",
    source: "Google",
    text: "We needed a security guard in Orlando to help with theft and other security concerns. The service exceeded our expectations completely."
  },
  {
    id: 4,
    name: "L. Bernard",
    date: "November 1, 2022",
    source: "Google",
    text: "Their armed and unarmed security guards in Miami are used by several of our companies. We saved significantly while improving our security posture."
  },
  {
    id: 5,
    name: "Faith A. Vasquez",
    date: "November 1, 2022",
    source: "Google",
    text: "These individuals are extremely qualified. Their two military guards came on time and were professional throughout the entire engagement."
  },
  {
    id: 6,
    name: "Gabby Forester",
    date: "October 31, 2022",
    source: "Google",
    text: "They are competent, responsive, and accommodating; I enthusiastically endorse them. I called them for an emergency and they responded immediately."
  }
];

export const stats = [
  { value: "3400+", label: "Clients Protected" },
  { value: "30+", label: "Years of Experience" },
  { value: "600+", label: "Office Locations" },
  { value: "50", label: "States Served" }
];

export const faqs = [
  {
    id: 1,
    question: "What measures are in place to ensure the safety and reliability of your security guards?",
    answer: "Armed Security Service conducts thorough background checks, continuous performance evaluations, and ongoing training to maintain the safety, reliability, and professionalism of our security guards."
  },
  {
    id: 2,
    question: "Can I request security guards for short-term or one-time events?",
    answer: "Yes, Armed Security Service provides security solutions for short-term events, as well as long-term contracts. We tailor our services to meet the unique needs of each client, regardless of the duration."
  },
  {
    id: 3,
    question: "What is the process for requesting security guard services?",
    answer: "Clients can contact us via phone or our website to discuss their security needs. We will then conduct a consultation to determine the best security solution and create a customized security plan."
  },
  {
    id: 4,
    question: "What is the geographic coverage of Armed Security Service?",
    answer: "Armed Security Service operates nationwide, providing security services across various cities and states throughout the United States to meet our clients' needs."
  },
  {
    id: 5,
    question: "What types of industries or clients do you typically serve?",
    answer: "We serve a diverse range of industries, including but not limited to corporate, retail, residential, event management, healthcare, educational institutions, construction sites, and government facilities."
  },
  {
    id: 6,
    question: "What services do your security guards provide?",
    answer: "Armed Security Service provides a range of security services, including but not limited to site monitoring, access control, patrol services, event security, and executive protection."
  },
  {
    id: 7,
    question: "How Much Does a Security Guard Cost?",
    answer: "We have the most competitive pricing in the nation. Our pricing depends on factors including: How many guards you need, how long you need the guards for, and whether you require armed or unarmed guards. Call or message us now to get accurate pricing based on your needs."
  },
  {
    id: 8,
    question: "Are You Licensed And Insured?",
    answer: "Yes! When you hire a security guard team from Armed Security Service, you can rest assured knowing that all our guards are fully licensed and insured to meet all regulations in the state they are working in. Our guards are insured with both professional and general liabilities."
  },
  {
    id: 9,
    question: "Do I Have to Sign a Long-Term Contract?",
    answer: "No. We offer pay-as-you-go options, short-term security guards and long-term contracts if needed."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Winter 2025-2026 Fire Watch Readiness: Protecting Properties Nationwide",
    excerpt: "Introduction: The Freeze Is Coming — and So Are the Fire Watch Requirements...",
    image: "https://images.unsplash.com/photo-1723399726195-1fc25450f80d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzZWN1cml0eSUyMHBhdHJvbHxlbnwwfHx8fDE3Njg4OTI4MjJ8MA&ixlib=rb-4.1.0&q=85",
    date: "November 27, 2025",
    comments: 0
  },
  {
    id: 2,
    title: "Event Security Contract Costs: How Major Venues Budget Per Event",
    excerpt: "Seven hours before doors open, the command center is already buzzing. Twenty monitors show empty seats...",
    image: "https://images.unsplash.com/photo-1552739883-6578dc150ac6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxhcm1lZCUyMGd1YXJkfGVufDB8fHx8MTc2ODg5MjgzNHww&ixlib=rb-4.1.0&q=85",
    date: "November 22, 2025",
    comments: 0
  },
  {
    id: 3,
    title: "Executive Protection Pricing: What Individuals Pay for 24/7 Security",
    excerpt: "The Math of Staying Alive: He almost missed the pattern. Three cities, three appearances...",
    image: "https://images.pexels.com/photos/13569269/pexels-photo-13569269.jpeg",
    date: "November 21, 2025",
    comments: 0
  }
];

export const states = [
  ["Alabama", "Arizona", "California", "Colorado", "Florida"],
  ["Georgia", "Illinois", "Indiana", "Kentucky", "Louisiana"],
  ["Maryland", "Massachusetts", "Michigan", "Minnesota", "Nevada"],
  ["New Jersey", "New York", "Pennsylvania", "Tennessee", "New Mexico"],
  ["Texas", "Utah", "Virginia", "Washington", "West Virginia"],
  ["Wisconsin", "Wyoming", "Ohio", "South Carolina", "North Carolina"]
];

export const serviceTypes = [
  "Unarmed Security",
  "Armed Security",
  "Event Security",
  "Fire Watch Guards",
  "Private Investigations"
];

export const clientLogos = [
  "Burlington",
  "La Quinta",
  "Fendi Casa",
  "Metro Hotels",
  "City Bank",
  "Tech Corp"
];

export const securityFeatures = [
  { icon: "Clock", title: "Open 24 Hours", description: "Round-the-clock security coverage" },
  { icon: "Shield", title: "Security Guards", description: "Professional trained personnel" },
  { icon: "AlertTriangle", title: "Emergency Security", description: "Rapid response teams" },
  { icon: "Eye", title: "Surveillance", description: "Advanced monitoring systems" },
  { icon: "Award", title: "Licensed & Insured", description: "Fully certified operations" }
];

export const armedSecurityInfo = {
  title: "Armed Security Guards",
  image: "https://images.pexels.com/photos/14164536/pexels-photo-14164536.jpeg",
  points: [
    {
      title: "Unwavering Dedication to Security",
      description: "Our armed security officers are hand-selected based on their extensive law enforcement and military backgrounds, ensuring an unmatched level of industry expertise."
    },
    {
      title: "Rapid and Efficient Reaction",
      description: "Our armed security personnel are strategically positioned and trained to respond quickly to any situation. This swift response can make all the difference in mitigating risks."
    },
    {
      title: "As a Deterrent to Crime",
      description: "Armed security guards can function as an effective deterrent against criminal activity simply by their presence. Our guards are equipped with the skills to handle high-pressure situations."
    }
  ]
};

export const unarmedSecurityInfo = {
  title: "Unarmed Security Guards",
  image: "https://images.unsplash.com/photo-1566245024852-04fbf7842ce9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxzZWN1cml0eSUyMGd1YXJkfGVufDB8fHx8MTc2ODg5MjgxN3ww&ixlib=rb-4.1.0&q=85",
  points: [
    {
      title: "Professional and Approachable Attitude",
      description: "The training of unarmed security officers includes maintaining a professional and approachable demeanor, fostering a positive environment."
    },
    {
      title: "Conflict Management and Customer Service",
      description: "Our security officers are trained in conflict resolution and customer service. They can effectively manage conflicts and difficult situations with composure."
    },
    {
      title: "Enhanced Monitoring and Reporting",
      description: "Unarmed security officers are adept at observing and reporting suspicious activities. Their keen observational abilities contribute to proactive security measures."
    },
    {
      title: "Community Participation and Positive Image",
      description: "Unarmed security officers can create a friendly and reassuring environment by interacting positively with the community."
    }
  ]
};

export const vehiclePatrolInfo = {
  title: "Vehicle Patrol Security",
  image: "https://images.pexels.com/photos/7715249/pexels-photo-7715249.jpeg",
  points: [
    {
      title: "Routine Patrols",
      description: "Our vehicle patrol security officers conduct routine and methodical patrols of your property and vicinity, minimizing security vulnerabilities."
    },
    {
      title: "Emergency Procedures",
      description: "Our vehicle patrol security officers are trained to respond quickly and effectively in the event of an emergency."
    },
    {
      title: "Response to Alarms and Notifications",
      description: "In the event of security alarms or alerts, our vehicle patrol security guards respond expeditiously, investigating the source and taking appropriate action."
    },
    {
      title: "Communication and Collaboration",
      description: "Communication and cooperation are essential components of our vehicle patrol security responsibilities for seamless coordination."
    }
  ]
};